module.exports = __webpack_public_path__ + "static/media/peroni_minifrigo.93543f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni_minifrigo.png
// module id = 812
// module chunks = 0